import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { Navigation } from './Navigation'
import { Footer } from './Footer'
import { FloatingQuoteWidget } from '../FloatingQuoteWidget'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      {isHomePage && <FloatingQuoteWidget />}
    </div>
  )
}
